import { ProductAdditionListNode } from "../../../apiHooks";
import { Typography } from "../../../components";
import { BulletedList } from "../../../components/BulletedList";
import { useNextTranslation } from "../../../hooks";
import { ListItem } from "../ListItem";
import { ProductSectionTitle } from "../ProductSectionTitle";
import { ProductSectionWrapper, ProductSectionWrapperProps } from "./ProductSectionWrapper";

type ProductAdditionsSectionProps = Omit<ProductSectionWrapperProps, "children"> & {
    additions: ProductAdditionListNode[];
};
export const ProductAdditionsSection = ({ additions, ...props }: ProductAdditionsSectionProps) => {
    const [t] = useNextTranslation("product");

    return (
        <ProductSectionWrapper {...props} data-testid="product-additions-section">
            <ProductSectionTitle>{t("label.extraAvailable")}</ProductSectionTitle>
            <div data-testid="product-additions-content">
                <Typography color="subtle">{t("description.additions")}</Typography>
                <ProductAdditions additions={additions} />
            </div>
        </ProductSectionWrapper>
    );
};

export const ProductAdditions = ({ additions }: { additions: ProductAdditionsSectionProps["additions"] }) => {
    return (
        <BulletedList>
            {additions.map((addition, idx) => (
                <ListItem key={idx}>
                    <Typography color="subtle" size="large">
                        {addition.name}
                    </Typography>
                    <Typography color="subtle" size="large">
                        {addition.description}
                    </Typography>
                </ListItem>
            ))}
        </BulletedList>
    );
};
